import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Settings } from 'lucide-react';
import { MetricTileManager } from './MetricTileManager';

export function CustomizeMetricsButton() {
  const [showManager, setShowManager] = useState(false);

  return (
    <>
      <button
        onClick={() => setShowManager(true)}
        className="text-xs text-muted-foreground hover:text-primary transition-colors"
      >
        Customize Metrics
      </button>

      {showManager && (
        <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-[100] flex items-center justify-center p-4">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            className="bg-background rounded-xl border border-border max-w-md w-full overflow-hidden"
          >
            <div className="p-4 border-b border-border flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Settings className="w-4 h-4 text-primary" />
                <h2 className="text-base font-medium">Customize Metrics</h2>
              </div>
              <button
                onClick={() => setShowManager(false)}
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                Done
              </button>
            </div>

            <div className="p-4">
              <MetricTileManager onClose={() => setShowManager(false)} />
            </div>
          </motion.div>
        </div>
      )}
    </>
  );
}